import 'theme/moydom/less/pages/rules.less';
import $ from 'jquery';

$(() => {
    if ($('.js-autoscroll')) {
        var tag = $('.js-autoscroll').data('id');

        if (tag != null) {
            $('html, body').animate(
                {
                    scrollTop: $('.js-autoscroll-id-' + tag).offset().top - 90,
                },
                800,
                function () {}
            );
        }
    }
});
